import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import addRes from './add.json';
import deleteByIdRes from './deleteById.json';
import getAllByTypeRes from './getAllByType.json';
import getAllRolesRes from './getAllRoles.json';
import updateRes from './update.json';
import getUserDetailsRes from './getUserDetails.json';

const getAllRoles = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}user-roles`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRolesRes>(url, config);
};

// Type : 0. Active , 1. Deleted
const getAllByType = (typeUser: number, page?:string, size?:string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}display-users?deleted=${typeUser}&page=${page ?? 0}&size=${size ?? 1000}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllByTypeRes>(url, config);
};

const getAllByRole = (roleId: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}all-users-by-role?roleId=${roleId}&deleted=0`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllByTypeRes>(url, config);
};

interface AddNewUser {
    'username':string;
    'password':string;
    'firstname':string;
    'lastname':string;
    'position':string;
    'role':string;
}

const add = (data:AddNewUser) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-user`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof addRes>(url, { ...data }, config);
};

export interface UpdateUser {
    'id'?: string | number;
    'username'?:string;
    'firstname':string;
    'lastname':string;
    'position':string;
    'phoneNumber':string;
    'role'?:string;
}

const update = (data:UpdateUser) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-user`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof updateRes>(url, { ...data }, config);
};

const updatePassword = (data: {password: string}) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}change-pass`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof updateRes>(url, { ...data }, config);
};

const deleteById = (id:number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}delete-user`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post<typeof deleteByIdRes>(url, { id }, config);
};

const getProfileDetails = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-user-profile`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getUserDetailsRes>(url, config);
};

const user = {
  getAllRoles,
  getAllByType,
  getAllByRole,
  add,
  update,
  deleteById,
  getProfileDetails,
  updatePassword,
};

export default user;
